module.exports = __webpack_public_path__ + "img/1x.b934da0.jpg";